<template>
  <v-form>
    <v-container>
      <v-row justify="space-between">
        <v-col class="text-center" cols="12">
          <span style="color: red; font-size: 2em; font-weight: bold">
            {{ $vuetify.lang.t('$vuetify.pages.pageNotFound') }}
          </span>
        </v-col>
      </v-row>
      <v-row v-if="display_back_button" justify="space-between">
        <v-col class="text-center" cols="12">
          <v-btn center @click="$router.push({ path: '/', query: $route.query })">
            {{ $vuetify.lang.t('$vuetify.btn.back') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
export default {
  data: () => {
    return {
      display_back_button: true,
    };
  },
  computed: {
    setup() {
      const result = this.$store.getters['credential/SETUP'];
      return result;
    },
  },
  async created() {
    if (this.$route.query.mso === 'on') {
      this.display_back_button = false;
    }
  },
};
</script>
